module.exports = __webpack_public_path__ + "static/media/icon_change.18fdb7ac.jpg";